// @flow

import { createTheme } from "@mui/material/styles";

let theme = createTheme({
  appColors: {
    priority: {
      low: "#ff9800",
      medium: "#ffd600",
      high: "#8bc34a",
      urgent: "#e91e63"
    },
    screensMade: {
      palette: {
        primary: {
          light: "#63ccff",
          main: "#f57c00",
          dark: "#006db3"
        },
        secondary: {
          light: "#FAFAFA",
          main: "#795548"
        }
      }
    },
    pullFromStock: {
      palette: {
        primary: {
          light: "#63ccff",
          main: "#1b5e20",
          dark: "#006db3"
        },
        secondary: {
          light: "#FAFAFA",
          main: "#263238"
        }
      }
    }
  },
  typography: {
    useNextVariants: true,
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5
    }
  },
  palette: {
    mode: "light",
    primary: {
      light: "#63ccff",
      main: "#009be5",
      dark: "#006db3"
    },
    secondary: {
      light: "#FAFAFA",
      main: "#e0e0e0"
    }
  },
  shape: {
    borderRadius: 8
  }
});

theme = {
  ...theme,
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
          "&:active": {
            boxShadow: "none"
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: theme.spacing(1)
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
          fontSize: 13,
          textTransform: "initial",
          margin: "0 16px",
          minWidth: 0,
          [theme.breakpoints.up("md")]: {
            minWidth: 0
          }
        },
        labelContainer: {
          padding: 0,
          [theme.breakpoints.up("md")]: {
            padding: 0
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1)
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingBottom: theme.spacing(0.5),
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(7),
          paddingTop: theme.spacing(0.5)
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        enterDelay: 1000,
        enterNextDelay: 1000
      },
      styleOverrides: {
        tooltip: {
          borderRadius: 4
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: `${theme.spacing(2)} !important`
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          zIndex: 1199
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: theme.typography.fontWeightMedium
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          marginRight: 0,
          "& svg": {
            fontSize: 20
          }
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32
        }
      }
    },
    MuiBadge: {
      styleOverrides: {
        colorError: {
          backgroundColor: "#B00020"
        },
        colorPrimary: {
          backgroundColor: "#00C853"
        },
        colorSecondary: {
          backgroundColor: "#2962FF"
        }
      }
    }
  },
  props: {
    MuiTab: {
      disableRipple: true
    }
  },
  mixins: {
    ...theme.mixins,
    toolbar: {
      minHeight: 48
    }
  }
};

const screensMadeTheme = {
  ...theme,
  components: {
    ...theme.components,
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: theme.appColors.screensMade.palette.primary.main
        }
      }
    }
  }
};

const pullFromStockTheme = {
  ...theme,
  components: {
    ...theme.components,
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: theme.appColors.pullFromStock.palette.primary.main
        }
      }
    }
  }
};

const colors = {
  customer_status: {
    active: "#2196F3",
    black_listed: "#B00020",
    blind_shipped: "#CFD8DC",
    complicated: "#F8E71C",
    high_value: "#7ED321"
  }
};

export default theme;
export { colors, pullFromStockTheme, screensMadeTheme };
